import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_ANALYTICS_TAX_CLIENTS_SUCCESS  action and sets an array of tax clients in the store
 * @param {Array} [state] The tax clients currently in the store, or the initial state
 * @param {Object} action The action to be handled
 * @returns {Array} The tax clients
 */
export default function analyticsTaxClientsDropdown(
  state = initialState.analyticsTaxClients,
  action
) {
  switch (action.type) {
    case actions.LOAD_ANALYTICS_TAX_CLIENTS_SUCCESS:
      return action.analyticsTaxClients;
    case actions.UNLOAD_CLIENT:
      return initialState.analyticsTaxClients;
    default:
      return state;
  }
}
